import React from 'react';
import Form from 'react-bootstrap/Form';

function TextAreaField({ field, label, value, onChange, error, controlId = "applicant", rows = 10, placeholder }) {
    return (
        <Form.Group className="mb-3" controlId={`${controlId}${field}`}>
            <Form.Label className="text-uppercase fw-bold">{label}</Form.Label>
            <Form.Control
                as="textarea"
                rows={rows}
                placeholder={placeholder !== undefined ? placeholder : label}
                value={value || ''}
                onChange={(e) => onChange(field, e.target.value)}
                isInvalid={!!error}
            />
            <Form.Control.Feedback type="invalid">
                {error}
            </Form.Control.Feedback>
        </Form.Group>
    );
}

export default TextAreaField;
